/**
 * constants/zIndex.ts
 *
 * Central z-index layering scale for the application.
 * All inline-style zIndex values must reference this object to keep
 * portaled components (Tooltip, DropdownMenu, toasts, modals, drag items)
 * deterministically stacked relative to one another.
 *
 * Tailwind utility classes (z-30, z-40, z-50, z-[9999]) used on non-portaled
 * elements map to the same conceptual tiers described here.
 *
 * Tier summary:
 *   DRAG    (10)   -- drag-and-drop ghost items
 *   STICKY  (30)   -- sticky bars (e.g. SettingsSaveBar)
 *   FAB     (40)   -- floating action buttons and overlay backdrops
 *   MODAL   (50)   -- modals, bottom-sheets, side-panels, popovers
 *   PICKER  (200)  -- pickers that must float above open modals (e.g. IconPicker)
 *   POPOVER (9999) -- portaled tooltips, dropdown menus, toasts (always on top)
 */
export const Z_INDEX = {
  DRAG: 10,
  STICKY: 30,
  FAB: 40,
  MODAL: 50,
  PICKER: 200,
  POPOVER: 9999,
} as const;
